<template lang="pug">
.card-item
  .card-item__side
    .card-item__focus
    .card-item__cover
      img.card-item__bg(:src="image.original", alt="")
    .card-item__wrapper
      .card-item__title {{ name }}
      .qrcode-wrapper(@click="showQR = true")
        qrcode-vue.card-item__qr(:value="code", :size="70" level="H", background="#fff", foreground="#000")
        span(style="font-size:13px;margin-top:5px;") {{ $t('cards.zoom') }}
      // .card-item__show-qr(@click="showQR = true") {{ $t('cards.showQR') }} &#9995;
      .card-item__number
        span
          template(v-for="(num, index) in outCode")
            .card-item__numberItem(:data-index="index") {{ num }}
      //- .card-item__actions
      //-   .card-item__delete(@click="$emit('delete')") Удалить
  // .card-item__close
    button.cls(@click="$emit('delete')" style="cursor: pointer;")
  section.popup(v-if="showQR")
    .popup__overlay
    .popup__view(@click="showQR = false")
      // .popup__body
        .popup__close(@click="close")
          icon(name="close")
        // .popup__header Вход в кабинет
        // .popup__main
      .qr_wrapper
        qrcode-vue(:value="code", :size="200" level="H", background="#fff", foreground="#000")
</template>
<script>
import QrcodeVue from 'qrcode.vue';
export default {
  components: {
    QrcodeVue,
  },
  name: 'VbCard',
  props: {
    code: {
      type: String,
      required: false,
      default: '',
    },
    image: {
      type: Object,
      required: false,
      default: {},
    },
    name: {
      type: String,
      required: false,
      default: '',
    }
  },
  data: () => ({
    outCode: [],
    showQR: false,
  }),
  mounted() {
    this.outCode = this.code.split('').reduce((arr, element, index) => {
      arr.push(element);
      if ((index + 1) % 4 === 0) {
        arr.push(' ');
      }
      return arr;
    }, []);
    this.outCode.splice(-1);
  },
  methods: {
  }
};
</script>
<style lang="scss">
.glass {
  position: absolute;
  top:40%;
  left:35%;
}
.qrcode-wrapper {
  display: flex;
  flex-direction: column;
  widows: fit-content;
  background: #fff;
  position: absolute;
  right: 1rem;
  top: 1rem;
  // border: 3px solid #000;
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.qr_wrapper {
  height: 240px;
  width: 240px;
  background: #fff;
  border: 6px solid #000;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-item {
  // max-width: 320 / 16 + rem;
  @media screen and (min-width: 960px) {
    max-width: 320 / 16 + rem;
  }
  height: 200 / 16 + rem;
  margin: 32 / 16 + rem 0 0;
  // margin-left: auto;
  // margin-right: auto;
  position: relative;
  // z-index: 2;
  width: 100%;
  @media screen and (max-width: 480px) {
    // max-width: 310 / 16 + rem;
    // height: 220 / 16 + rem;
    height: 15.75rem;
    width: 100%;
  }
  @media screen and (max-width: 360px) {
    // height: 180 / 16 + rem;
  }
  &__side {
    border-radius: 15 / 16 + rem;
    overflow: hidden;
    // box-shadow: 0 20 / 16 + rem 60 / 16 + rem 0 rgba(14, 42, 90, 0.55);
    transform-style: preserve-3d;
    transition: all 0.8s cubic-bezier(0.71, 0.03, 0.56, 0.85);
    backface-visibility: hidden;
    height: 100%;
  }
  &__bg {
    max-width: 100%;
    display: block;
    max-height: 100%;
    height: 100%;
    width: 100%;
    object-fit: cover;
    filter: brightness(0.7);
  }
  &__cover {
    height: 100%;
    background-color: #1c1d27;
    position: absolute;
    height: 100%;
    background-color: #1c1d27;
    left: 0;
    top: 0;
    width: 100%;
    border-radius: 15 / 16 + rem;
    overflow: hidden;
    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      // background: rgba(6, 2, 29, 0.45);
    }
  }
  &__wrapper {
    font-family: monospace;
    padding: 25 / 16 + rem 15 / 16 + rem;
    position: relative;
    z-index: 4;
    height: 100%;
    // text-shadow: 7 / 16 + rem 6 / 16 + rem 10 / 16 + rem rgba(14, 42, 90, 0.8);
    @media screen and (max-width: 480px) {
      padding: 20 / 16 + rem 10 / 16 + rem;
    }
  }
  &__qr {
    // position: absolute;
    // right: 1.5rem;
    // top: 1rem;
  }
  &__show-qr {
    position: absolute;
    left: 1.5rem;
    top: 1.5rem;
    color:#ffde00;
    cursor:pointer;
    font-weight: 600;
  }
  &__name {
    font-family: "Montserrat", sans-serif;
    font-weight: 500;
    line-height: 1;
    color: #fff;
    font-size: 24 / 16 + rem;
    display: inline-block;
    padding: 10 / 16 + rem 15 / 16 + rem;
    user-select: none;
  }
  &__actions {
    text-align: right;
  }
  &__delete {
    font-family: "Montserrat", sans-serif;
    font-weight: 500;
    line-height: 1;
    color: rgb(255, 198, 198);
    font-size: 24 / 16 + rem;
    display: inline-block;
    padding: 10 / 16 + rem 15 / 16 + rem;
    cursor: pointer;
    user-select: none;
    transition: all .25s ease;
    &:hover {
      text-shadow: 0 0 20px #000;
      color: #f44336;
    }
  }
  &__close {
    position: absolute;
    right: -1rem;
    top: -1rem;
    height: 2rem;
    width: 2rem;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    .cls {
      border: 1px solid #999;
      height: 1.5rem;
      width: 1.5rem;
      border-radius: 50%;
      background: #fff;
      display: flex;
      position: relative;
      &:before, &:after {
        position: absolute;
        left: 9px;
        top: 3px;
        content: ' ';
        height: 1rem;
        width: 1px;
        background-color: #999;
      }
      &:after {
        transform: rotate(-45deg);
      }
      &:before {
        transform: rotate(45deg);
      }
    }
  }
  &__title {
    position: absolute;
    top: 1rem;
    left: 1rem;
    font-size: 13px;
    color: #fff;
    width: 50%;
    line-height: 1.1rem;
    font-weight: 600;
    @media screen and (max-width: 960px) {
      line-height: 1.4rem;
    }
  }
  &__number {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    font-weight: 500;
    line-height: 1;
    color: #fff;
    font-size: .8rem;
    // margin-top: 60 / 16 + rem;
    display: inline-block;
    // padding: 10 / 16 + rem 15 / 16 + rem;
    cursor: pointer;

    // @media screen and (max-width: 480px) {
    //   font-size: 21 / 16 + rem;
    //   margin-bottom: 15 / 16 + rem;
    //   padding: 10 / 16 + rem 10 / 16 + rem;
    // }

    // @media screen and (max-width: 360px) {
    //   font-size: 19 / 16 + rem;
    //   margin-bottom: 10 / 16 + rem;
    //   padding: 10 / 16 + rem 10 / 16 + rem;
    // }
  }
  &__numberItem {
    width: .5rem;
    display: inline-block;
    // &.-active {
    //   width: 30 / 16 + rem;
    // }

    // @media screen and (max-width: 480px) {
    //   width: 13 / 16 + rem;

    //   &.-active {
    //     width: 16 / 16 + rem;
    //   }
    // }

    // @media screen and (max-width: 360px) {
    //   width: 12 / 16 + rem;

    //   &.-active {
    //     width: 8 / 16 + rem;
    //   }
    // }
  }
}
</style>
